import * as api from 'src/api/ban/globalBan';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GlobalBanUser, initialState } from './state';
import { GlobalBanActionResponse } from 'src/admin-entity/interface/global-ban/global-ban-response.interface';

export const fetchGlobalBanList = createAsyncThunk<
    { list: GlobalBanUser[]; nextPage: string | null },
    string | null | undefined,
    { rejectValue: string }
>('globalBan/fetchList', async (nextPage, thunkAPI) => {
    try {
        const res = await api.fetchGlobalBanList(nextPage);

        const globalBanInfos: GlobalBanUser[] = res.data.list.map(u => ({
            appUserId: u.appUserId,
            name: u.name,
            nickname: u.nickname,
            profileImageUrl: u.profileImageUrl,
            phone: u.phone,
            banDate: u.banDate,
            banMemo: u.banMemo,
        }));

        return { list: globalBanInfos, nextPage: res.data.page.nextPage ?? null };
    } catch (err: any) {
        return thunkAPI.rejectWithValue('전역 차단 목록을 불러오는 데 실패했습니다.');
    }
});

export const addGlobalBan = createAsyncThunk<GlobalBanActionResponse, number, { rejectValue: string }>(
    'globalBan/add',
    async (appUserId, thunkAPI) => {
        try {
            const res = await api.addGlobalBan(appUserId);
            return res.data;
        } catch (err: any) {
            return thunkAPI.rejectWithValue('전역 차단 추가에 실패했습니다.');
        }
    },
);

export const unbanGlobalUser = createAsyncThunk<GlobalBanActionResponse, number, { rejectValue: string }>(
    'globalBan/unban',
    async (appUserId, thunkAPI) => {
        try {
            const res = await api.unbanGlobalChatUser(appUserId);
            return res.data;
        } catch (err: any) {
            return thunkAPI.rejectWithValue('전역 차단 해제에 실패했습니다.');
        }
    },
);

const globalBanSlice = createSlice({
    name: 'globalBan',
    initialState,
    reducers: {
        clearGlobalBan(state) {
            state.list = [];
            state.nextPage = null;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchGlobalBanList.pending, state => {
            state.isLoading = true;
        });
        builder.addCase(fetchGlobalBanList.fulfilled, (state, action) => {
            const isLoadMore = Boolean(action.meta.arg);
            state.list = isLoadMore ? [...state.list, ...action.payload.list] : action.payload.list;
            state.nextPage = action.payload.nextPage;
            state.isLoading = false;
        });
        builder.addCase(fetchGlobalBanList.rejected, state => {
            state.isLoading = false;
        });
        builder.addCase(addGlobalBan.fulfilled, (state, action) => {
            const newUser: GlobalBanUser = {
                ...action.payload.appUser,
                appUserId: action.payload.appUser.id,
                banDate: new Date().toISOString(),
            };
            state.list.push(newUser);
        });
        builder.addCase(unbanGlobalUser.fulfilled, (state, action) => {
            const removeId = action.payload.appUser.id;
            state.list = state.list.filter(u => u.appUserId !== removeId);
        });
    },
});

export const { clearGlobalBan } = globalBanSlice.actions;
export default globalBanSlice.reducer;
